// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simplestream .pausead-container {
    position: absolute; 
    top: 0px; 
    left: 0px; 
    width: 100%; 
    height: 100%;
    display: flex; 
    flex-direction: column; 
    z-index: -1;
    background: black;
}
.simplestream .pausead-container .pausead-safearea {
    flex-grow: 1; 
    width: 100%; 
    height: 100%; 
    display: flex; 
    align-items: center; 
    justify-content: center;
}
.simplestream .pausead-container .pausead-controls {
    padding: 10px; 
    display: flex; 
    justify-content: center;
}
.simplestream .pausead-container .pausead-controls .pausead-button {
    padding: 10px 20px; 
    color: white;
    cursor: pointer;
    border: 1px solid white;
}
.simplestream .pausead-container .pausead-slot {
    background: #111111;
    display: none; /* no pause ad by defult */
}
@media (min-width: 753px) and (min-height: 424px) { /* use 640x360 if player has >753px width */
    .simplestream .pausead-container .pausead-slot {
        display: block;
        width: 640px; 
        height: 360px;
    }
}
@media (min-width: 1002px) and (min-height: 564px) { /* use 900x500 if player has >1002px width */
    .simplestream .pausead-container .pausead-slot {
        display: block;
        width: 900px; 
        height: 500px;
    }
}`, "",{"version":3,"sources":["webpack://./src/plugins/pausead/PauseAdPlugin.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,aAAa,EAAE,0BAA0B;AAC7C;AACA,oDAAoD,2CAA2C;IAC3F;QACI,cAAc;QACd,YAAY;QACZ,aAAa;IACjB;AACJ;AACA,qDAAqD,4CAA4C;IAC7F;QACI,cAAc;QACd,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".simplestream .pausead-container {\n    position: absolute; \n    top: 0px; \n    left: 0px; \n    width: 100%; \n    height: 100%;\n    display: flex; \n    flex-direction: column; \n    z-index: -1;\n    background: black;\n}\n.simplestream .pausead-container .pausead-safearea {\n    flex-grow: 1; \n    width: 100%; \n    height: 100%; \n    display: flex; \n    align-items: center; \n    justify-content: center;\n}\n.simplestream .pausead-container .pausead-controls {\n    padding: 10px; \n    display: flex; \n    justify-content: center;\n}\n.simplestream .pausead-container .pausead-controls .pausead-button {\n    padding: 10px 20px; \n    color: white;\n    cursor: pointer;\n    border: 1px solid white;\n}\n.simplestream .pausead-container .pausead-slot {\n    background: #111111;\n    display: none; /* no pause ad by defult */\n}\n@media (min-width: 753px) and (min-height: 424px) { /* use 640x360 if player has >753px width */\n    .simplestream .pausead-container .pausead-slot {\n        display: block;\n        width: 640px; \n        height: 360px;\n    }\n}\n@media (min-width: 1002px) and (min-height: 564px) { /* use 900x500 if player has >1002px width */\n    .simplestream .pausead-container .pausead-slot {\n        display: block;\n        width: 900px; \n        height: 500px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
